import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Iframe from 'react-iframe'
import CountUp from 'react-countup';
import Youtube from '../headerone/Youtube'


function About(props) {

    const [video, setVideo] = useState();


  return (
    <>
        <section className="about-area about-p pt-80 p-relative fix" >
            
            <div className="container">
                <div className="row">
                    <div className="col-12">

                        <div className="row justify-content-center align-items-center bgColor" >
                            <div className="col-lg-6 col-md-12 col-sm-12 px-5 py-5 c-video">
                                <Youtube />
                            </div>
                            
                            <div className="col-lg-6 col-md-12 col-sm-12">
                                
                                <div className="about-content s-about-content pl-15 pb-30 pt-30 pr-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">
                                    <h5>
                                    <i className="fal fa-graduation-cap" /> About Our Institute
                                    </h5>
                                    <h2 className='titleh3'>A Few Words About IIT Tirupati</h2>
                                </div>
                                <p className="txt-clr caboutus">
                                IIT Tirupati has a high potential to be an Academic and Research Institute of great repute.
                                </p>
                                <p  className="caboutus">
                                    The Indian Institute of Technology Tirupati (IIT Tirupati), established in 2015, is an autonomous Institute under Ministry of Education, Government of India. It is declared as an Institute of National Importance under the Act of Parliament of India (Institutes of Technology Act, 1961).<br />
                                </p>
                                {props.showVisionMission=="yes" &&
                                <>
                                <div className="about-content2">
                                    <div className="row">
                                    <div className="col-md-12">
                                        <ul className="green2">
                                        <li>
                                            <div className="abcontent">
                                            {/* <div className="ano">
                                                <span>01</span>
                                            </div> */}
                                            {" "}
                                            <div className="text">
                                                <h3>Vision</h3>{" "}
                                                <p>
                                                IIT Tirupati will be a leading center of higher education...
                                                </p>
                                            </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="abcontent">
                                                {/* <div className="ano">
                                                    <span>02</span>
                                                </div> */}
                                            {" "}
                                            <div className="text">
                                                <h3>Mission</h3>{" "}
                                                <p>
                                                To educate undergraduate and postgraduate students...
                                                </p>
                                            </div>
                                            </div>
                                        </li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                                <div className="slider-btn mt-20">
                                    <Link to="/aboutus" className="btn ss-btn smoth-scroll">
                                    Read More <i className="fal fa-long-arrow-right" />
                                    </Link>
                                </div>
                                </>
                                }
                                </div>
                            </div>
                        </div>



                        
                    </div>
                </div>
                
            </div>





            <div className="counter-area pb-90" style={{ background: "#da4a47" }}>
                <div className="container">
                    <div className="row p-relative">
                    
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={114} ></CountUp>
                            <p>+<br/>Faculty</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-wow-offset="100" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={128} >  </CountUp>
                            <p>+<br/>Staff</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={1523} ></CountUp>
                            <p>+<br/>Students
                            </p>
                        </div>
                        </div>
                    </div>


                                {/* Ram disable below code before 8 month */}
                    {/* <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="single-counter wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                        <div className="counter p-relative" style={{ backgroundImage: "url(assets/img/bg/c-object.png)", backgroundRepeat: "no-repeat" }} >
                            <CountUp className="count" start={0} end={220} ></CountUp>
                            <p>+<br/>Publications
                            </p>
                        </div>
                        </div>
                    </div> */}


                    
                    </div>
                </div>

                
            </div>




        </section>

        

       

    </>
  )
}

export default About